function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Table = e() : t.Table = e();
}(window, function () {
  return function (t) {
    var e = {};

    function o(n) {
      if (e[n]) return e[n].exports;
      var i = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(i.exports, i, i.exports, o), i.l = !0, i.exports;
    }

    return o.m = t, o.c = e, o.d = function (t, e, n) {
      o.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, o.t = function (t, e) {
      if (1 & e && (t = o(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        o.d(n, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return n;
    }, o.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return o.d(e, "a", e), e;
    }, o.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, o.p = "", o(o.s = 3);
  }([function (t, e) {
    t.exports = function (t) {
      var e = [];
      return e.toString = function () {
        return this.map(function (e) {
          var o = function (t, e) {
            var o = t[1] || "",
                n = t[3];
            if (!n) return o;

            if (e && "function" == typeof btoa) {
              var i = (l = n, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(l)))) + " */"),
                  r = n.sources.map(function (t) {
                return "/*# sourceURL=" + n.sourceRoot + t + " */";
              });
              return [o].concat(r).concat([i]).join("\n");
            }

            var l;
            return [o].join("\n");
          }(e, t);

          return e[2] ? "@media " + e[2] + "{" + o + "}" : o;
        }).join("");
      }, e.i = function (t, o) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var n = {}, i = 0; i < this.length; i++) {
          var r = this[i][0];
          "number" == typeof r && (n[r] = !0);
        }

        for (i = 0; i < t.length; i++) {
          var l = t[i];
          "number" == typeof l[0] && n[l[0]] || (o && !l[2] ? l[2] = o : o && (l[2] = "(" + l[2] + ") and (" + o + ")"), e.push(l));
        }
      }, e;
    };
  }, function (t, e, o) {
    var n,
        i,
        r = {},
        l = (n = function n() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === i && (i = n.apply(this, arguments)), i;
    }),
        s = function (t) {
      var e = {};
      return function (t, o) {
        if ("function" == typeof t) return t();

        if (void 0 === e[t]) {
          var n = function (t, e) {
            return e ? e.querySelector(t) : document.querySelector(t);
          }.call(this, t, o);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (t) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }(),
        a = null,
        c = 0,
        h = [],
        d = o(6);

    function u(t, e) {
      for (var o = 0; o < t.length; o++) {
        var n = t[o],
            i = r[n.id];

        if (i) {
          i.refs++;

          for (var l = 0; l < i.parts.length; l++) {
            i.parts[l](n.parts[l]);
          }

          for (; l < n.parts.length; l++) {
            i.parts.push(g(n.parts[l], e));
          }
        } else {
          var s = [];

          for (l = 0; l < n.parts.length; l++) {
            s.push(g(n.parts[l], e));
          }

          r[n.id] = {
            id: n.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function f(t, e) {
      for (var o = [], n = {}, i = 0; i < t.length; i++) {
        var r = t[i],
            l = e.base ? r[0] + e.base : r[0],
            s = {
          css: r[1],
          media: r[2],
          sourceMap: r[3]
        };
        n[l] ? n[l].parts.push(s) : o.push(n[l] = {
          id: l,
          parts: [s]
        });
      }

      return o;
    }

    function p(t, e) {
      var o = s(t.insertInto);
      if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var n = h[h.length - 1];
      if ("top" === t.insertAt) n ? n.nextSibling ? o.insertBefore(e, n.nextSibling) : o.appendChild(e) : o.insertBefore(e, o.firstChild), h.push(e);else if ("bottom" === t.insertAt) o.appendChild(e);else {
        if ("object" != _typeof(t.insertAt) || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var i = s(t.insertAt.before, o);
        o.insertBefore(e, i);
      }
    }

    function _(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);
      var e = h.indexOf(t);
      e >= 0 && h.splice(e, 1);
    }

    function b(t) {
      var e = document.createElement("style");

      if (void 0 === t.attrs.type && (t.attrs.type = "text/css"), void 0 === t.attrs.nonce) {
        var n = function () {
          0;
          return o.nc;
        }();

        n && (t.attrs.nonce = n);
      }

      return v(e, t.attrs), p(t, e), e;
    }

    function v(t, e) {
      Object.keys(e).forEach(function (o) {
        t.setAttribute(o, e[o]);
      });
    }

    function g(t, e) {
      var o, n, i, r;

      if (e.transform && t.css) {
        if (!(r = "function" == typeof e.transform ? e.transform(t.css) : e.transform["default"](t.css))) return function () {};
        t.css = r;
      }

      if (e.singleton) {
        var l = c++;
        o = a || (a = b(e)), n = w.bind(null, o, l, !1), i = w.bind(null, o, l, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (o = function (t) {
        var e = document.createElement("link");
        return void 0 === t.attrs.type && (t.attrs.type = "text/css"), t.attrs.rel = "stylesheet", v(e, t.attrs), p(t, e), e;
      }(e), n = function (t, e, o) {
        var n = o.css,
            i = o.sourceMap,
            r = void 0 === e.convertToAbsoluteUrls && i;
        (e.convertToAbsoluteUrls || r) && (n = d(n));
        i && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(i)))) + " */");
        var l = new Blob([n], {
          type: "text/css"
        }),
            s = t.href;
        t.href = URL.createObjectURL(l), s && URL.revokeObjectURL(s);
      }.bind(null, o, e), i = function i() {
        _(o), o.href && URL.revokeObjectURL(o.href);
      }) : (o = b(e), n = function (t, e) {
        var o = e.css,
            n = e.media;
        n && t.setAttribute("media", n);
        if (t.styleSheet) t.styleSheet.cssText = o;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(o));
        }
      }.bind(null, o), i = function i() {
        _(o);
      });

      return n(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          n(t = e);
        } else i();
      };
    }

    t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");
      (e = e || {}).attrs = "object" == _typeof(e.attrs) ? e.attrs : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = l()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var o = f(t, e);
      return u(o, e), function (t) {
        for (var n = [], i = 0; i < o.length; i++) {
          var l = o[i];
          (s = r[l.id]).refs--, n.push(s);
        }

        t && u(f(t, e), e);

        for (i = 0; i < n.length; i++) {
          var s;

          if (0 === (s = n[i]).refs) {
            for (var a = 0; a < s.parts.length; a++) {
              s.parts[a]();
            }

            delete r[s.id];
          }
        }
      };
    };

    var m,
        y = (m = [], function (t, e) {
      return m[t] = e, m.filter(Boolean).join("\n");
    });

    function w(t, e, o, n) {
      var i = o ? "" : n.css;
      if (t.styleSheet) t.styleSheet.cssText = y(e, i);else {
        var r = document.createTextNode(i),
            l = t.childNodes;
        l[e] && t.removeChild(l[e]), l.length ? t.insertBefore(r, l[e]) : t.appendChild(r);
      }
    }
  }, function (t, e) {
    t.exports = '<svg viewBox="0 0 20 20"><circle cx="10" cy="10" r="10" fill="#388AE5"></circle><path fill="#FFF" d="M10.9 9.1h3.7a.9.9 0 1 1 0 1.8h-3.7v3.7a.9.9 0 1 1-1.8 0v-3.7H5.4a.9.9 0 0 1 0-1.8h3.7V5.4a.9.9 0 0 1 1.8 0v3.7z"></path></svg>';
  }, function (t, e, o) {
    var n = o(12).TableConstructor,
        i = o(11),
        r = {
      input: "tc-table__inp"
    };

    t.exports = /*#__PURE__*/function () {
      _createClass(_class, null, [{
        key: "isReadOnlySupported",
        get: function get() {
          return !0;
        }
      }, {
        key: "enableLineBreaks",
        get: function get() {
          return !0;
        }
      }, {
        key: "toolbox",
        get: function get() {
          return {
            icon: i,
            title: "Table"
          };
        }
      }]);

      function _class(_ref) {
        var t = _ref.data,
            e = _ref.config,
            o = _ref.api,
            i = _ref.readOnly;

        _classCallCheck(this, _class);

        this.api = o, this.readOnly = i, this._tableConstructor = new n(t, e, o, i);
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          return this._tableConstructor.htmlElement;
        }
      }, {
        key: "save",
        value: function save(t) {
          var e = [],
              o = t.querySelector("table").rows;

          for (var _t = 0; _t < o.length; _t++) {
            var _n = o[_t],
                _i = Array.from(_n.cells).map(function (t) {
              return t.querySelector("." + r.input);
            });

            _i.every(this._isEmpty) || e.push(_i.map(function (t) {
              return t.innerHTML;
            }));
          }

          return {
            content: e
          };
        }
      }, {
        key: "_isEmpty",
        value: function _isEmpty(t) {
          return !t.textContent.trim();
        }
      }]);

      return _class;
    }();
  }, function (t, e, o) {
    var n = o(5);
    "string" == typeof n && (n = [[t.i, n, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    o(1)(n, i);
    n.locals && (t.exports = n.locals);
  }, function (t, e, o) {
    (t.exports = o(0)(!1)).push([t.i, ".tc-editor{padding:10px;position:relative;box-sizing:content-box;width:100%;left:-10px}", ""]);
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var o = e.protocol + "//" + e.host,
          n = o + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var i,
            r = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(r) ? t : (i = 0 === r.indexOf("//") ? r : 0 === r.indexOf("/") ? o + r : n + r.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")");
      });
    };
  }, function (t, e, o) {
    var n = o(8);
    "string" == typeof n && (n = [[t.i, n, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    o(1)(n, i);
    n.locals && (t.exports = n.locals);
  }, function (t, e, o) {
    (t.exports = o(0)(!1)).push([t.i, ".tc-toolbar{background:#368be6;}.tc-toolbar--hidden{visibility:hidden}.tc-toolbar--hor{width:100%;height:21px;flex-direction:row;left:0;top:1px}.tc-toolbar--hor,.tc-toolbar--ver{display:flex;align-items:center;position:absolute;z-index:100}.tc-toolbar--ver{height:100%;width:21px;flex-direction:column;top:0;left:-1px}.tc-toolbar__plus{height:21px;width:21px;margin-top:0;}.tc-toolbar__plus--hor{margin-left:-10px}.tc-toolbar__plus--ver{margin-top:-10px}.tc-toolbar__shine-line--hor{min-height:1px;width:100%}.tc-toolbar__shine-line--ver{min-width:1px;height:100%}", ""]);
  }, function (t, e, o) {
    var n = o(10);
    "string" == typeof n && (n = [[t.i, n, ""]]);
    var i = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    o(1)(n, i);
    n.locals && (t.exports = n.locals);
  }, function (t, e, o) {
    (t.exports = o(0)(!1)).push([t.i, ".tc-table{width:100%;height:100%;border-collapse:collapse;table-layout:fixed;}.tc-table__wrap{border:1px solid #dbdbe2;border-radius:3px;position:relative;height:100%;width:100%;box-sizing:border-box}.tc-table__cell{border:1px solid #dbdbe2;padding:0;vertical-align:top}.tc-table__area{padding:10px;height:100%}.tc-table__inp{outline:none;flex-grow:100;min-height:1.5em;height:100%;overflow:hidden}.tc-table tbody tr:first-child td{border-top:none}.tc-table tbody tr:last-child td{border-bottom:none}.tc-table tbody tr td:last-child{border-right:none}.tc-table tbody tr td:first-child{border-left:none}", ""]);
  }, function (t, e) {
    t.exports = '<svg width="18" height="14"><path d="M2.833 8v1.95a1.7 1.7 0 0 0 1.7 1.7h3.45V8h-5.15zm0-2h5.15V2.35h-3.45a1.7 1.7 0 0 0-1.7 1.7V6zm12.3 2h-5.15v3.65h3.45a1.7 1.7 0 0 0 1.7-1.7V8zm0-2V4.05a1.7 1.7 0 0 0-1.7-1.7h-3.45V6h5.15zM4.533.1h8.9a3.95 3.95 0 0 1 3.95 3.95v5.9a3.95 3.95 0 0 1-3.95 3.95h-8.9a3.95 3.95 0 0 1-3.95-3.95v-5.9A3.95 3.95 0 0 1 4.533.1z"></path></svg>';
  }, function (t, e, o) {
    "use strict";

    o.r(e);
    o(4);

    function n(t) {
      return !(null == t);
    }

    function i(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var r = document.createElement(t);
      if (n(e)) for (var _t2 = 0; _t2 < e.length; _t2++) {
        n(e[_t2]) && r.classList.add(e[_t2]);
      }
      if (n(o)) for (var _t3 in o) {
        r.setAttribute(_t3, o[_t3]);
      }
      if (n(i)) for (var _t4 = 0; _t4 < i.length; _t4++) {
        n(i[_t4]) && r.appendChild(i[_t4]);
      }
      return r;
    }

    function r(t) {
      var e = t.getBoundingClientRect();
      return {
        y1: Math.floor(e.top + window.pageYOffset),
        x1: Math.floor(e.left + window.pageXOffset),
        x2: Math.floor(e.right + window.pageXOffset),
        y2: Math.floor(e.bottom + window.pageYOffset)
      };
    }

    function l(t, e, o) {
      var n;
      return e - t.x1 >= -1 && e - t.x1 <= 11 && (n = "left"), t.x2 - e >= -1 && t.x2 - e <= 11 && (n = "right"), o - t.y1 >= -1 && o - t.y1 <= 11 && (n = "top"), t.y2 - o >= -1 && t.y2 - o <= 11 && (n = "bottom"), n;
    }

    o(7);
    var s = o(2),
        a = o.n(s);
    var c = {
      highlightingLine: "tc-toolbar",
      hidden: "tc-toolbar--hidden",
      horizontalToolBar: "tc-toolbar--hor",
      horizontalHighlightingLine: "tc-toolbar__shine-line--hor",
      verticalToolBar: "tc-toolbar--ver",
      verticalHighlightingLine: "tc-toolbar__shine-line--ver",
      plusButton: "tc-toolbar__plus",
      horizontalPlusButton: "tc-toolbar__plus--hor",
      verticalPlusButton: "tc-toolbar__plus--ver",
      area: "tc-table__area"
    };

    var h = /*#__PURE__*/function () {
      function h() {
        _classCallCheck(this, h);

        this._plusButton = this._generatePlusButton(), this._highlightingLine = this._generateHighlightingLine(), this._toolbar = this._generateToolBar([this._plusButton, this._highlightingLine]);
      }

      _createClass(h, [{
        key: "hide",
        value: function hide() {
          this._toolbar.classList.add(c.hidden);
        }
      }, {
        key: "show",
        value: function show() {
          this._toolbar.classList.remove(c.hidden), this._highlightingLine.classList.remove(c.hidden);
        }
      }, {
        key: "hideLine",
        value: function hideLine() {
          this._highlightingLine.classList.add(c.hidden);
        }
      }, {
        key: "_generatePlusButton",
        value: function _generatePlusButton() {
          var _this = this;

          var t = i("div", [c.plusButton]);
          return t.innerHTML = a.a, t.addEventListener("click", function (t) {
            t.stopPropagation();
            var e = new CustomEvent("click", {
              detail: {
                x: t.pageX,
                y: t.pageY
              },
              bubbles: !0
            });

            _this._toolbar.dispatchEvent(e);
          }), t;
        }
      }, {
        key: "_generateHighlightingLine",
        value: function _generateHighlightingLine() {
          var _this2 = this;

          var t = i("div", [c.highlightingLine]);
          return t.addEventListener("click", function (t) {
            t.stopPropagation();
            var e = new CustomEvent("click", {
              bubbles: !0
            });

            _this2._toolbar.dispatchEvent(e);
          }), t;
        }
      }, {
        key: "_generateToolBar",
        value: function _generateToolBar(t) {
          var _this3 = this;

          var e = i("div", [c.hidden], null, t);
          return e.addEventListener("mouseleave", function (t) {
            _this3._recalcMousePos(t);
          }), e;
        }
      }, {
        key: "_recalcMousePos",
        value: function _recalcMousePos(t) {
          this.hide();
          var e = document.elementFromPoint(t.pageX, t.pageY);

          if (null !== e && e.classList.contains(c.area)) {
            var _o = new MouseEvent("mouseover", {
              clientX: t.pageX,
              clientY: t.pageY
            });

            e.dispatchEvent(_o);
          }
        }
      }, {
        key: "htmlElement",
        get: function get() {
          return this._toolbar;
        }
      }]);

      return h;
    }();

    var d = /*#__PURE__*/function (_h) {
      _inherits(d, _h);

      var _super = _createSuper(d);

      function d() {
        var _this4;

        _classCallCheck(this, d);

        _this4 = _super.call(this), _this4._toolbar.classList.add(c.horizontalToolBar), _this4._plusButton.classList.add(c.horizontalPlusButton), _this4._highlightingLine.classList.add(c.horizontalHighlightingLine);
        return _this4;
      }

      _createClass(d, [{
        key: "showIn",
        value: function showIn(t) {
          var e = Math.floor(Number.parseInt(window.getComputedStyle(this._toolbar).height) / 2);
          this._toolbar.style.top = t - e + "px", this.show();
        }
      }]);

      return d;
    }(h);

    var u = /*#__PURE__*/function (_h2) {
      _inherits(u, _h2);

      var _super2 = _createSuper(u);

      function u() {
        var _this5;

        _classCallCheck(this, u);

        _this5 = _super2.call(this), _this5._toolbar.classList.add(c.verticalToolBar), _this5._plusButton.classList.add(c.verticalPlusButton), _this5._highlightingLine.classList.add(c.verticalHighlightingLine);
        return _this5;
      }

      _createClass(u, [{
        key: "showIn",
        value: function showIn(t) {
          var e = Math.floor(Number.parseInt(window.getComputedStyle(this._toolbar).width) / 2);
          this._toolbar.style.left = t - e + "px", this.show();
        }
      }]);

      return u;
    }(h);

    o(9);
    var f = {
      table: "tc-table",
      inputField: "tc-table__inp",
      cell: "tc-table__cell",
      wrapper: "tc-table__wrap",
      area: "tc-table__area"
    };

    var p = /*#__PURE__*/function () {
      function p(t) {
        _classCallCheck(this, p);

        this.readOnly = t, this._numberOfColumns = 0, this._numberOfRows = 0, this._element = this._createTableWrapper(), this._table = this._element.querySelector("table"), this.readOnly || this._hangEvents();
      }

      _createClass(p, [{
        key: "addColumn",
        value: function addColumn() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
          this._numberOfColumns++;
          var e = this._table.rows;

          for (var _o2 = 0; _o2 < e.length; _o2++) {
            var _n2 = e[_o2].insertCell(t);

            this._fillCell(_n2);
          }
        }
      }, {
        key: "addRow",
        value: function addRow() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
          this._numberOfRows++;

          var e = this._table.insertRow(t);

          return this._fillRow(e), e;
        }
      }, {
        key: "_createTableWrapper",
        value: function _createTableWrapper() {
          return i("div", [f.wrapper], null, [i("table", [f.table])]);
        }
      }, {
        key: "_createContenteditableArea",
        value: function _createContenteditableArea() {
          return i("div", [f.inputField], {
            contenteditable: !this.readOnly
          });
        }
      }, {
        key: "_fillCell",
        value: function _fillCell(t) {
          t.classList.add(f.cell);

          var e = this._createContenteditableArea();

          t.appendChild(i("div", [f.area], null, [e]));
        }
      }, {
        key: "_fillRow",
        value: function _fillRow(t) {
          for (var _e = 0; _e < this._numberOfColumns; _e++) {
            var _e2 = t.insertCell();

            this._fillCell(_e2);
          }
        }
      }, {
        key: "_hangEvents",
        value: function _hangEvents() {
          var _this6 = this;

          this._table.addEventListener("focus", function (t) {
            _this6._focusEditField(t);
          }, !0), this._table.addEventListener("blur", function (t) {
            _this6._blurEditField(t);
          }, !0), this._table.addEventListener("keydown", function (t) {
            _this6._pressedEnterInEditField(t);
          }), this._table.addEventListener("click", function (t) {
            _this6._clickedOnCell(t);
          }), this._table.addEventListener("mouseover", function (t) {
            _this6._mouseEnterInDetectArea(t), t.stopPropagation();
          }, !0);
        }
      }, {
        key: "_focusEditField",
        value: function _focusEditField(t) {
          t.target.classList.contains(f.inputField) && (this._selectedCell = t.target.closest("." + f.cell));
        }
      }, {
        key: "_blurEditField",
        value: function _blurEditField(t) {
          t.target.classList.contains(f.inputField) && (this._selectedCell = null);
        }
      }, {
        key: "_pressedEnterInEditField",
        value: function _pressedEnterInEditField(t) {
          t.target.classList.contains(f.inputField) && (13 !== t.keyCode || t.shiftKey || t.preventDefault());
        }
      }, {
        key: "_clickedOnCell",
        value: function _clickedOnCell(t) {
          if (!t.target.classList.contains(f.cell)) return;
          t.target.querySelector("." + f.inputField).focus();
        }
      }, {
        key: "_mouseEnterInDetectArea",
        value: function _mouseEnterInDetectArea(t) {
          if (!t.target.classList.contains(f.area)) return;
          var e = l(r(t.target.closest("TD")), t.pageX, t.pageY);
          t.target.dispatchEvent(new CustomEvent("mouseInActivatingArea", {
            detail: {
              side: e
            },
            bubbles: !0
          }));
        }
      }, {
        key: "htmlElement",
        get: function get() {
          return this._element;
        }
      }, {
        key: "body",
        get: function get() {
          return this._table;
        }
      }, {
        key: "selectedCell",
        get: function get() {
          return this._selectedCell;
        }
      }]);

      return p;
    }();

    o.d(e, "TableConstructor", function () {
      return b;
    });
    var _ = {
      editor: "tc-editor",
      toolBarHor: "tc-toolbar--hor",
      toolBarVer: "tc-toolbar--ver",
      inputField: "tc-table__inp"
    };

    var b = /*#__PURE__*/function () {
      function b(t, e, o, n) {
        _classCallCheck(this, b);

        this.readOnly = n, this._table = new p(n);

        var r = this._resizeTable(t, e);

        this._fillTable(t, r), this._container = i("div", [_.editor, o.styles.block], null, [this._table.htmlElement]), this._verticalToolBar = new u(), this._horizontalToolBar = new d(), this._table.htmlElement.appendChild(this._horizontalToolBar.htmlElement), this._table.htmlElement.appendChild(this._verticalToolBar.htmlElement), this._hoveredCell = null, this._activatedToolBar = null, this._hoveredCellSide = null, this._plusButDelay = null, this._toolbarShowDelay = null, this.readOnly || this._hangEvents();
      }

      _createClass(b, [{
        key: "_fillTable",
        value: function _fillTable(t, e) {
          if (void 0 !== t.content) for (var _o3 = 0; _o3 < e.rows && _o3 < t.content.length; _o3++) {
            for (var _n3 = 0; _n3 < e.cols && _n3 < t.content[_o3].length; _n3++) {
              this._table.body.rows[_o3].cells[_n3].querySelector("." + _.inputField).innerHTML = t.content[_o3][_n3];
            }
          }
        }
      }, {
        key: "_resizeTable",
        value: function _resizeTable(t, e) {
          var o = Array.isArray(t.content),
              n = !!o && t.content.length,
              i = o ? t.content.length : void 0,
              r = n ? t.content[0].length : void 0,
              l = Number.parseInt(e.rows),
              s = Number.parseInt(e.cols),
              a = !isNaN(l) && l > 0 ? l : void 0,
              c = !isNaN(s) && s > 0 ? s : void 0,
              h = i || a || 2,
              d = r || c || 2;

          for (var _t5 = 0; _t5 < h; _t5++) {
            this._table.addRow();
          }

          for (var _t6 = 0; _t6 < d; _t6++) {
            this._table.addColumn();
          }

          return {
            rows: h,
            cols: d
          };
        }
      }, {
        key: "_showToolBar",
        value: function _showToolBar(t, e) {
          this._hideToolBar(), this._activatedToolBar = t, t.showIn(e);
        }
      }, {
        key: "_hideToolBar",
        value: function _hideToolBar() {
          null !== this._activatedToolBar && this._activatedToolBar.hide();
        }
      }, {
        key: "_hangEvents",
        value: function _hangEvents() {
          var _this7 = this;

          this._container.addEventListener("mouseInActivatingArea", function (t) {
            _this7._toolbarCalling(t);
          }), this._container.addEventListener("click", function (t) {
            _this7._clickToolbar(t);
          }), this._container.addEventListener("input", function () {
            _this7._hideToolBar();
          }), this._container.addEventListener("keydown", function (t) {
            _this7._containerKeydown(t);
          }), this._container.addEventListener("mouseout", function (t) {
            _this7._leaveDetectArea(t);
          }), this._container.addEventListener("mouseover", function (t) {
            _this7._mouseEnterInDetectArea(t);
          });
        }
      }, {
        key: "_mouseInActivatingAreaListener",
        value: function _mouseInActivatingAreaListener(t) {
          this._hoveredCellSide = t.detail.side;
          var e = r(t.target),
              o = r(this._table.htmlElement);

          if (this._hoveredCell = t.target.closest("TD"), null === this._hoveredCell) {
            var _t7 = 11;
            this._hoveredCell = this._container, e.x1 += _t7, e.y1 += _t7, e.x2 -= _t7, e.y2 -= _t7;
          }

          "top" === this._hoveredCellSide && this._showToolBar(this._horizontalToolBar, e.y1 - o.y1 - 2), "bottom" === this._hoveredCellSide && this._showToolBar(this._horizontalToolBar, e.y2 - o.y1 - 1), "left" === this._hoveredCellSide && this._showToolBar(this._verticalToolBar, e.x1 - o.x1 - 2), "right" === this._hoveredCellSide && this._showToolBar(this._verticalToolBar, e.x2 - o.x1 - 1);
        }
      }, {
        key: "_isToolbar",
        value: function _isToolbar(t) {
          return !(!t.closest("." + _.toolBarHor) && !t.closest("." + _.toolBarVer));
        }
      }, {
        key: "_leaveDetectArea",
        value: function _leaveDetectArea(t) {
          this._isToolbar(t.relatedTarget) || (clearTimeout(this._toolbarShowDelay), this._hideToolBar());
        }
      }, {
        key: "_toolbarCalling",
        value: function _toolbarCalling(t) {
          var _this8 = this;

          this._isToolbar(t.target) || (clearTimeout(this._toolbarShowDelay), this._toolbarShowDelay = setTimeout(function () {
            _this8._mouseInActivatingAreaListener(t);
          }, 125));
        }
      }, {
        key: "_clickToolbar",
        value: function _clickToolbar(t) {
          if (!this._isToolbar(t.target)) return;
          var e;

          if (this._activatedToolBar === this._horizontalToolBar ? (this._addRow(), e = "y") : (this._addColumn(), e = "x"), isNaN(t.detail) && null !== t.detail) {
            var _o4 = r(this._table.htmlElement);

            var _n4;

            _n4 = "x" === e ? t.detail.x - _o4.x1 : t.detail.y - _o4.y1, this._delayAddButtonForMultiClickingNearMouse(_n4);
          } else this._hideToolBar();
        }
      }, {
        key: "_containerKeydown",
        value: function _containerKeydown(t) {
          13 === t.keyCode && this._containerEnterPressed(t);
        }
      }, {
        key: "_delayAddButtonForMultiClickingNearMouse",
        value: function _delayAddButtonForMultiClickingNearMouse(t) {
          var _this9 = this;

          this._showToolBar(this._activatedToolBar, t), this._activatedToolBar.hideLine(), clearTimeout(this._plusButDelay), this._plusButDelay = setTimeout(function () {
            _this9._hideToolBar();
          }, 500);
        }
      }, {
        key: "_getHoveredSideOfContainer",
        value: function _getHoveredSideOfContainer() {
          return this._hoveredCell === this._container ? this._isBottomOrRight() ? 0 : -1 : 1;
        }
      }, {
        key: "_isBottomOrRight",
        value: function _isBottomOrRight() {
          return "bottom" === this._hoveredCellSide || "right" === this._hoveredCellSide;
        }
      }, {
        key: "_addRow",
        value: function _addRow() {
          var t = this._hoveredCell.closest("TR");

          var e = this._getHoveredSideOfContainer();

          1 === e && (e = t.sectionRowIndex, e += this._isBottomOrRight()), this._table.addRow(e);
        }
      }, {
        key: "_addColumn",
        value: function _addColumn() {
          var t = this._getHoveredSideOfContainer();

          1 === t && (t = this._hoveredCell.cellIndex, t += this._isBottomOrRight()), this._table.addColumn(t);
        }
      }, {
        key: "_containerEnterPressed",
        value: function _containerEnterPressed(t) {
          if (null === this._table.selectedCell || t.shiftKey) return;

          var e = this._table.selectedCell.closest("TR");

          var o = this._getHoveredSideOfContainer();

          1 === o && (o = e.sectionRowIndex + 1), this._table.addRow(o).cells[0].click();
        }
      }, {
        key: "_mouseEnterInDetectArea",
        value: function _mouseEnterInDetectArea(t) {
          var e = l(r(this._container), t.pageX, t.pageY);
          t.target.dispatchEvent(new CustomEvent("mouseInActivatingArea", {
            detail: {
              side: e
            },
            bubbles: !0
          }));
        }
      }, {
        key: "htmlElement",
        get: function get() {
          return this._container;
        }
      }]);

      return b;
    }();
  }]);
});